import { useNavigate } from 'react-router-dom'
import { type TransferOptionSelected } from '../../../components/molecules/MoveProductsSelector.molecule'
import { useAtom } from 'jotai/index'
import { useEffect, useState } from 'react'
import { useGoToContainerDetail } from '../container-detail/ContainerDetail.navigator'
import { moveOptionAtom, selectedContainerReader } from '../Storage.state'
import { MoveOption } from '../Storage.types'
import { useGoToStorageScanDestinationDetail } from '../scan-destination/StorageScanDestination.navigator'


export const useMoveOptions = () => {
  const navigate = useNavigate()

  const [selectedContainer] = useAtom(selectedContainerReader)
  const [, setMoveOption] = useAtom(moveOptionAtom)

  const containerDetailNavigator = useGoToContainerDetail()
  const scanDestinationNavigator = useGoToStorageScanDestinationDetail()
  
  const options = ['move-container', 'move-products'] as MoveOption[]

  return {
    origin: selectedContainer.container.name,
    options,
    actions: {
      back: () => {
        navigate(-1)
      },
      onClickGo: (option: MoveOption) => () => {
        setMoveOption(option)
        if(option === 'move-products') {
          containerDetailNavigator.go(selectedContainer?.container.name as string)
        }
        else{
          scanDestinationNavigator.go(selectedContainer?.container.name as string, option)
        }
      }
    }
  }
}
